import { defineMessages } from 'react-intl';

/** design: trial-upsell a1 (first file), b1 (pill), b2 (Home card), b3 (takeover). */
export const watermarkTrialMessages = defineMessages({
  pillRunning: {
    id: 'app.sml.upsell.watermark.pill.running',
    defaultMessage: '{count, plural, one {# file carries} other {# files carry}} the watermark.',
  },
  pillLastDay: {
    id: 'app.sml.upsell.watermark.pill.lastDay',
    defaultMessage: 'Tomorrow {count, plural, one {# file keeps} other {# files keep}} the watermark.',
  },
  pillFree: {
    id: 'app.sml.upsell.watermark.pill.free',
    defaultMessage: '{count, plural, one {# file has} other {# files have}} the watermark. Nothing was charged.',
  },
  endsTomorrow: { id: 'app.sml.upsell.watermark.endsTomorrow', defaultMessage: 'Your trial ends tomorrow' },
  onFreeNow: { id: 'app.sml.upsell.watermark.onFreeNow', defaultMessage: 'You are on Free now' },
  onFree: { id: 'app.sml.upsell.watermark.onFree', defaultMessage: 'You are on Free' },
  cardTitle: {
    id: 'app.sml.upsell.watermark.card.title',
    defaultMessage: '{song} is ready to post. Only the watermark is left.',
  },
  cardTitleNoSong: {
    id: 'app.sml.upsell.watermark.card.titleNoSong',
    defaultMessage: 'Your files are ready to post. Only the watermark is left.',
  },
  cardBody: {
    id: 'app.sml.upsell.watermark.card.body',
    defaultMessage:
      'A plan makes clean copies of your {count, plural, one {# file} other {# files}}. You pay no credits for them.',
  },
  later: { id: 'app.sml.upsell.watermark.card.later', defaultMessage: 'Later' },
  firstEyebrow: { id: 'app.sml.upsell.watermark.first.eyebrow', defaultMessage: 'Your first file' },
  // QA 2026-10-28 (lit-7): say what is on the file, with no word game.
  firstTitle: {
    id: 'app.sml.upsell.watermark.first.titleLogo',
    defaultMessage: 'Your first file for {song} is ready. It has the MUSIC24 logo on it.',
  },
  firstTitleNoSong: {
    id: 'app.sml.upsell.watermark.first.titleLogoNoSong',
    defaultMessage: 'Your first file is ready. It has the MUSIC24 logo on it.',
  },
  // QA 2026-10-28 impr2-1: "your first file" was wrong when the kit had 14 files already.
  firstEyebrowMany: { id: 'app.sml.upsell.watermark.first.eyebrowMany', defaultMessage: 'Your first files' },
  firstTitleMany: {
    id: 'app.sml.upsell.watermark.first.titleLogoMany',
    defaultMessage: 'Your first {count} files for {song} are ready. They have the MUSIC24 logo on them.',
  },
  firstTitleManyNoSong: {
    id: 'app.sml.upsell.watermark.first.titleLogoManyNoSong',
    defaultMessage: 'Your first {count} files are ready. They have the MUSIC24 logo on them.',
  },
  firstBody: {
    id: 'app.sml.upsell.watermark.first.body',
    defaultMessage:
      'On the trial, each file has the MUSIC24 mark and is half size. A plan gives you the clean file in full size.',
  },
  firstBodyFree: {
    id: 'app.sml.upsell.watermark.first.bodyFree',
    defaultMessage:
      'On Free, each file has the MUSIC24 mark and is half size. A plan gives you the clean file in full size.',
  },
  firstNow: { id: 'app.sml.upsell.watermark.first.now', defaultMessage: 'Now, on the trial' },
  firstNowFree: { id: 'app.sml.upsell.watermark.first.nowFree', defaultMessage: 'Now, on Free' },
  firstNowValue: {
    id: 'app.sml.upsell.watermark.first.nowValue',
    defaultMessage: '{width} × {height} · watermark',
  },
  firstPlan: { id: 'app.sml.upsell.watermark.first.plan', defaultMessage: 'On a plan' },
  firstPlanValue: {
    id: 'app.sml.upsell.watermark.first.planValue',
    defaultMessage: '{width} × {height} · only your name',
  },
  firstFine: {
    id: 'app.sml.upsell.watermark.first.finePaid',
    defaultMessage: 'Paid plan: {plan}, {price} a month. Cancel at any time.',
  },
  firstKeep: { id: 'app.sml.upsell.watermark.first.keep', defaultMessage: 'Keep the watermark for now' },
  takeoverTitleLastDay: {
    id: 'app.sml.upsell.watermark.takeover.title.lastDay',
    defaultMessage:
      'You made {count, plural, one {# file} other {# files}} for {song}. Tomorrow {count, plural, one {it keeps} other {they keep}} the watermark.',
  },
  takeoverTitleLastDayNoSong: {
    id: 'app.sml.upsell.watermark.takeover.title.lastDayNoSong',
    defaultMessage:
      'You made {count, plural, one {# file} other {# files}}. Tomorrow {count, plural, one {it keeps} other {they keep}} the watermark.',
  },
  takeoverTitleFree: {
    id: 'app.sml.upsell.watermark.takeover.title.free',
    defaultMessage: 'You are on Free now. Your {count, plural, one {# file has} other {# files have}} the watermark.',
  },
  takeoverTitleNoTrial: {
    id: 'app.sml.upsell.watermark.takeover.title.noTrial',
    defaultMessage:
      'Your {count, plural, one {# file has} other {# files have}} the MUSIC24 watermark. A plan removes it.',
  },
  takeoverFine: {
    id: 'app.sml.upsell.watermark.takeover.fine',
    defaultMessage: 'On Free your files stay, with the watermark and in preview size. New files have it too.',
  },
  monthly: { id: 'app.sml.upsell.watermark.takeover.monthly', defaultMessage: 'Monthly' },
  yearly: {
    id: 'app.sml.upsell.watermark.takeover.yearly',
    defaultMessage: 'Yearly · {months, plural, one {# month} other {# months}} free',
  },
  planPrefix: {
    id: 'app.sml.upsell.watermark.takeover.planPrefix',
    defaultMessage: 'No watermark, full size.',
  },
  takeoverCta: {
    id: 'app.sml.upsell.watermark.takeover.cta',
    defaultMessage: 'Remove the watermark from {count, plural, one {# file} other {# files}}',
  },
  takeoverDismissLastDay: {
    id: 'app.sml.upsell.watermark.takeover.dismiss.lastDay',
    defaultMessage: 'Go to Free with the watermark',
  },
  takeoverDismissFree: {
    id: 'app.sml.upsell.watermark.takeover.dismiss.free',
    defaultMessage: 'Stay on Free with the watermark',
  },
});
